import React from "react";
import BasePage from "components/BasePage";
import ConferenceStreamController from "./components/ConferenceStreamController";
import "./style.scss";
import useController from "./controller";

interface Props {
  conferenceUuid: string;
}

export default function PageConferenceChat({ conferenceUuid }: Props) {
  const { loading, ownerId, livechatSubject, onClose } = useController({ conferenceUuid });

  return (
    <BasePage className="page-conference-chat" loading={loading}>
      {livechatSubject && (
        <ConferenceStreamController
          livechatSubject={livechatSubject}
          conferenceUuid={conferenceUuid}
          ownerId={ownerId}
          onClose={onClose}
        />
      )}
    </BasePage>
  );
}
